import VueRouter from 'vue-router';
import home from '@/pages/home';
import contato from '@/pages/contato';
import projetos from '@/pages/projetos';
import galeria from '@/pages/galeria';
import projetoDetalhe from '@/pages/projeto_detalhe';

const routes = [
    { path: '/', component: home },
    { path: '/contato', component: contato },
    { path: '/projetos', component: projetos },
    { path: '/galeria', component: galeria },
    { path: '/galeria/:tipo', component: galeria },
    { path: '/projeto/:id', component: projetoDetalhe },
    { path: '*', redirect: { name: 'Page404', component: home }  },
  ];

export const router = new VueRouter({
  routes,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history'
});